import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { LanguageProvider } from "@/context/LanguageContext";
import { TrackingScripts } from "@/lib/tracking";
import { ProtectedRoute } from "@/components/admin/ProtectedRoute";

import PublicLayout from "@/layouts/PublicLayout";
import HomePage from "@/pages/HomePage";
import CoursePage from "@/pages/CoursePage";
import BlogIndexPage from "@/pages/BlogIndexPage";
import ArticlePage from "@/pages/ArticlePage";
import LoginPage from "@/pages/LoginPage";
import AdminCoursesPage from "@/pages/admin/AdminCoursesPage";
import AdminLeadsPage from "@/pages/admin/AdminLeadsPage";
import CourseEditorPage from "@/pages/admin/CourseEditorPage";
import SiteSettingsPage from "@/pages/admin/SiteSettingsPage";
import AdminArticlesPage from "@/pages/admin/AdminArticlesPage";
import ArticleEditorPage from "@/pages/admin/ArticleEditorPage";

function App() {
  return (
    <div className="App">
      <TrackingScripts />
      <LanguageProvider>
        <BrowserRouter>
          <AuthProvider>
            <Routes>
              <Route element={<PublicLayout />}>
                <Route path="/" element={<HomePage />} />
                <Route path="/corsi/:slug" element={<CoursePage />} />
                <Route path="/blog" element={<BlogIndexPage />} />
                <Route path="/blog/:slug" element={<ArticlePage />} />
              </Route>

              <Route path="/login" element={<LoginPage />} />
              <Route path="/admin" element={<ProtectedRoute><AdminCoursesPage /></ProtectedRoute>} />
              <Route path="/admin/leads" element={<ProtectedRoute><AdminLeadsPage /></ProtectedRoute>} />
              <Route path="/admin/sito" element={<ProtectedRoute><SiteSettingsPage /></ProtectedRoute>} />
              <Route path="/admin/corsi/nuovo" element={<ProtectedRoute><CourseEditorPage /></ProtectedRoute>} />
              <Route path="/admin/corsi/:id" element={<ProtectedRoute><CourseEditorPage /></ProtectedRoute>} />
              <Route path="/admin/blog" element={<ProtectedRoute><AdminArticlesPage /></ProtectedRoute>} />
              <Route path="/admin/blog/nuovo" element={<ProtectedRoute><ArticleEditorPage /></ProtectedRoute>} />
              <Route path="/admin/blog/:id" element={<ProtectedRoute><ArticleEditorPage /></ProtectedRoute>} />
            </Routes>
          </AuthProvider>
        </BrowserRouter>
      </LanguageProvider>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
